import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const DiamondLogo = () => {
    return (
        <svg
            // className={className ? className : ''}
            fill='currentColor'
            height='38'
            viewBox='0 0 27 38'
            width='27'
            xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_11256_384)'>
                <path
                    d='M18.5676 28.0096L15.3181 21.5103L10.4772 21.5185L18.5676 37.5926L26.6496 21.5103H21.8086L18.5676 28.0096Z'
                    fill='currentColor'/>
                <path
                    d='M10.9087 12.8576L15.3352 21.5845H21.8258L10.9087 0L0 21.5845H6.49882L10.9087 12.8576Z'
                    fill='currentColor'/>
            </g>
            <defs>
                <clipPath id='clip0_11256_384'>
                    <rect
                        fill='white'
                        height='37.6667'
                        width='26.6667'/>
                </clipPath>
            </defs>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
};

DiamondLogo.propTypes = propTypes;

export default DiamondLogo;
